import Vue from 'vue'
import axios from 'axios'
import router from '@/Router'
import store from '@/Store'
import { facilita } from '@/global'
import { storage } from '@/Services/Storage'

const api = axios.create({
    baseURL: facilita.api,
    withCredentials: true,
    headers: {
        'goscore-token': facilita.gstoken,
        'goscore-token-user': facilita.gstokenuser,
    },
})

const apiOff = axios.create({
    baseURL: facilita.apiOff,
})

const newApi = axios.create({
    baseURL: facilita.newApi,
    withCredentials: false,
    headers: {
        'goscore-token': facilita.gstoken,
        'goscore-token-user': facilita.gstokenuser,
		// 'Authorization': `Bearer ${facilita.gstokenuser}`
    },
})

Vue.use({
    install(Vue) {
        Vue.prototype.$api = api
        Vue.prototype.$apiOff = apiOff
    },
})

/** Interceptor para as chamadas da API */
api.interceptors.request.use(
    function(config) {
        return new Promise((resolve) => {
            const interval = setInterval(async () => {
                if (!store.getters.isRefreshing) {
                    clearInterval(interval)
                    /** Verifica se há um token no store, e caso haja insere o token na requisição */
                    if (store.getters.token) {
                        /** Caso o token esteja expirado, ativa a flag de refresh token */
                        if (store.getters.tokenExpired) {
                            await store.dispatch('auth/setIsRefreshing', true)
                        }
                        config.headers['Authorization'] = 'Bearer ' + store.getters.token
                    }

                    return resolve(config)
                }
            }, 200)
        })
    },
    function(error) {
        return Promise.reject(error)
    }
)

/** Interceptor para as chamadas da API que derem erro */
api.interceptors.response.use(
    (response) => response,
    async function(error) {
        if (!axios.isCancel(error)) {
            /** Mostra o erro no console */
            let userToken = storage.get('user_token')
            if ((error.response.status === 401 && userToken) || error.response.status === 400) {
                store.dispatch('auth/clearUserData')
            } else if (error.response.status === 403 && (userToken = error.response.data['token'])) {
                storage.set('user_token', userToken)
                await store.dispatch('auth/setToken', userToken)
                store.dispatch('auth/setIsRefreshing', false)
                error.config.headers['Authorization'] = 'Bearer ' + userToken
                error.config.baseURL = undefined
                return api.request(error.config)
            } else if (error.response.status !== 404) {
                router.push('/')
            }
        }

        return Promise.reject(error)
    }
)

export { api, apiOff, newApi }
